import React from "react";
import logo from "../assets/images/logo.svg";
import { Link } from "react-router-dom";
import { FaFacebook, FaXTwitter, FaLinkedin, FaCertificate } from "react-icons/fa6";
import { PHONES, EMAILS, ISO } from "../lib/contact";

function Footer() {
  return (
    <footer className="text-xs font-[350] w-full bg-brand-navy border-t-4 border-brand-yellow md:px-12 py-2 text-white flex flex-col items-center justify-center">
      <div className="flex flex-col md:flex-row items-start gap-7 md:gap-14 lg:gap-20 justify-start w-full px-4 sm:px-6 md:px-10 p-5">
        <div className="flex flex-col gap-5 w-full md:max-w-[25%]">
          <Link to="/">
            <img src={logo} alt="R.C. Bidave logo" className="bg-white rounded-lg p-1 w-32 sm:w-40 md:w-auto" />
          </Link>
          <p className="text-xs sm:text-sm">
          R.C. Bidave Civil Contractors and Suppliers provides expert services in RCC structures, waterproofing, and building repairs. With a focus on quality, safety, and efficiency, the company delivers durable and reliable construction solutions tailored to client needs.
          </p>
          <p className="inline-flex w-fit items-center gap-2 rounded-full border border-brand-yellow/60 bg-white/10 px-3 py-1.5 text-xs font-semibold text-brand-yellow">
            <FaCertificate aria-hidden="true" /> {ISO.standard} Certified
          </p>
        </div>
        <div className="flex flex-col gap-5 w-full md:max-w-[25%]">
          <h2 className="font-display font-bold text-sm sm:text-base text-brand-yellow">Quick Links</h2>
          <div className="flex gap-5 font-normal md:flex-col md:gap-1.5 lg:flex-row lg:gap-5">
            <ul className="flex flex-col gap-0.5 text-xs sm:text-sm">
              <li className="hover:scale-105">
                <Link to="/" className="inline-block py-1 hover:text-[#fed930] transition-all">
                  Home
                </Link>
              </li>
              <li className="hover:scale-105">
                <Link
                  to="/services"
                  className="inline-block py-1 hover:text-[#fed930] transition-all"
                >
                  Services
                </Link>
              </li>
              <li className="hover:scale-105">
                <Link
                  to="/projects-gallery"
                  className="inline-block py-1 hover:text-[#fed930] transition-all"
                >
                  Projects Gallery
                </Link>
              </li>
              {/* <li className="hover:scale-105">
                <Link
                  to="/gallery"
                  className="inline-block py-1 hover:text-[#fed930] transition-all"
                >
                  Gallery
                </Link>
              </li> */}
              {/* </ul>
            <ul className="flex flex-col gap-1.5"> */}
              <li className="hover:scale-105">
                <Link
                  to="/credentials"
                  className="inline-block py-1 hover:text-[#fed930] transition-all"
                >
                  Credentials
                </Link>
              </li>
              <li className="hover:scale-105">
                <Link
                  to="/clients"
                  className="inline-block py-1 hover:text-[#fed930] transition-all"
                >
                  Clients
                </Link>
              </li>
              {/* <li className="hover:scale-105">
                <Link
                  to="/member-login"
                  className="inline-block py-1 hover:text-[#fed930] transition-all"
                >
                  Member Login
                </Link>
              </li> */}
              <li className="hover:scale-105">
                <Link
                  to="/about-us"
                  className="inline-block py-1 hover:text-[#fed930] transition-all"
                >
                  About Us
                </Link>
              </li>
              <li className="hover:scale-105">
                <Link
                  to="/contact-us"
                  className="inline-block py-1 hover:text-[#fed930] transition-all"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col gap-5 w-full md:max-w-[25%]">
          <h2 className="font-display font-bold text-sm sm:text-base text-brand-yellow">Contact Info</h2>
          <div className="flex flex-col gap-2 text-xs sm:text-sm">
            <div>
              <h3 className="font-semibold">Address:</h3>
              <p>
                Plot No. A, 169, Khairane Rd, Dhirubhai Ambani Knowledge City,
                MIDC Industrial Area, Kopar Khairane, Navi Mumbai, Maharashtra 400710
              </p>
            </div>
            <div>
              <h3 className="font-semibold">Phone:</h3>
              {PHONES.map((p) => (
                <p key={p.tel}>
                  <a href={`tel:${p.tel}`} className="inline-block py-1 hover:text-[#fed930] transition-all">
                    {p.display} <span className="opacity-70">({p.label})</span>
                  </a>
                </p>
              ))}
            </div>
            <div>
              <h3 className="font-semibold">Email:</h3>
              {EMAILS.map((email) => (
                <p key={email}>
                  <a href={`mailto:${email}`} className="inline-block py-1 hover:text-[#fed930] transition-all break-all">
                    {email}
                  </a>
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
      <hr className="border-[#4b3f9a] w-full" />
      <div className="flex flex-col sm:flex-row w-full items-center justify-between p-5 gap-4">
        <div className="flex text-lg gap-3">
          <Link to="" aria-label="Facebook" className="p-2 -m-1 hover:text-[#0865ff] transition duration-300">
            <FaFacebook />
          </Link>
          <Link to="" aria-label="X (Twitter)" className="p-2 -m-1 hover:text-[#000000] transition duration-300">
            <FaXTwitter />
          </Link>
          <Link to="" aria-label="LinkedIn" className="p-2 -m-1 hover:text-[#0a66c2] transition duration-300">
            <FaLinkedin />
          </Link>
        </div>
        <div className="text-center sm:text-right text-xs sm:text-sm max-w-full sm:max-w-[50%]">
          Copyright 2015 RCB Govt. Civil Contractor
        </div>
      </div>
    </footer>
  );
}

export default Footer;
